import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Box, Button, Typography } from '@mui/material'
import WineryButton from 'core/WineryButton'
import Spinner from 'core/Spinner'

import { useWineryContext } from 'providers/WineryProvider'

const WineryTab = ({ multiplayer, wineRoomSelected, setWineRoomSelected }) => {
  const navigate = useNavigate()
  const { wineries } = useWineryContext()
  const [loading, setLoading] = useState(true)
  const [showOldGames, setShowOldGames] = useState(false)

  useEffect(() => {
    wineries && setLoading(false)
    return () => setLoading(true)
  }, [wineries])

  const handleClick = (winery) => {
    if (multiplayer) {
      setWineRoomSelected('wineRoomSelected', { name: winery.name, id: winery.id })
    } else {
      navigate(`/wine-room/${winery.id}`)
    }
  }

  return (
    <Box sx={{ mt: !multiplayer && 6, mb: 6 }}>
        {
          loading
            ? <Box sx={{ mt: 20 }}><Spinner /> </Box>
            : <div>
              {wineries && wineries
                .filter((winery) =>
                  showOldGames
                    ? typeof winery.menu_state === 'undefined' || winery.menu_state === 'old'
                    : winery.menu_state === 'current'
                )
                .map((winery, id) =>
                <WineryButton
                  key={id}
                  winery={winery}
                  multiplayer={multiplayer}
                  handleClick={() => handleClick(winery)}
                  isWineryChosen={wineRoomSelected?.id === winery.id}
                  index={id}
                />)}
                <div style={{ textAlign: 'center' }}>
                  <Button
                    onClick={() => setShowOldGames(!showOldGames)}
                    sx={{
                      width: 0.7,
                      height: 30,
                      px: 1,
                      py: 0,
                      m: 'auto',
                      mt: '1rem',
                      backgroundColor: 'white',
                      border: '1px solid black',
                      borderRadius: '50px'
                    }}
                  >
                    <Typography
                      fontFamily="DMSansMedium"
                      color="black"
                      fontSize={14}
                      sx={{ m: 0, p: 0 }}
                    >
                      {showOldGames ? 'Current games' : 'Previous games'}
                    </Typography>
                  </Button>
                </div>
              </div>
        }
    </Box>
  )
}

export default WineryTab
